import { KpiCard, Button, Chip } from '@/components/ui'
import { Download, DollarSign, MessageCircle, Receipt } from 'lucide-react'
import { campanas, templates } from '@/mock'
import { fmtMoney, fmtNumber } from '@/lib/utils'
import { cn } from '@/lib/utils'

export function CampanasCostos() {
  const totalMes = campanas.reduce((acc, c) => acc + c.stats.costoMes, 0)
  const mensajesMes = campanas.reduce((acc, c) => acc + c.stats.totalMes, 0)
  const totalPersonasMediaDia = campanas.reduce((acc, c) => acc + c.stats.personasHoy, 0)
  const totalRespMes = campanas.reduce((acc, c) => acc + Math.round(c.stats.respondieronHoy * (c.stats.totalMes / Math.max(c.stats.personasHoy, 1))), 0)
  const totalCostoMedia = campanas.reduce((acc, c) => acc + c.stats.personasHoy * 0.0125, 0)
  const promedioMsg = mensajesMes > 0 ? totalMes / mensajesMes : 0

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <KpiCard
          label="Costo del mes actual"
          value={fmtMoney(totalMes)}
          sub="USD · octubre 2026"
          icon={<DollarSign className="w-3.5 h-3.5" />}
          color="amber"
        />
        <KpiCard
          label="Mensajes enviados en el mes"
          value={fmtNumber(mensajesMes)}
          sub="todas camp."
          icon={<MessageCircle className="w-3.5 h-3.5" />}
        />
        <KpiCard
          label="Costo promedio por mensaje"
          value={fmtMoney(promedioMsg)}
          sub="tarifa Meta"
          icon={<Receipt className="w-3.5 h-3.5" />}
        />
      </div>

      <section className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <header className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
          <div>
            <h2 className="font-display text-lg text-navy-700">Desglose por campaña · Octubre 2026</h2>
            <p className="text-xs text-slate-500 mt-0.5">
              Media diaria = promedio por día activo · Total mes = acumulado del mes en curso
            </p>
          </div>
          <Button variant="outline" size="sm">
            <Download className="w-3.5 h-3.5" /> Export CSV
          </Button>
        </header>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-600 font-semibold">
                <th className="text-left px-4 py-2" rowSpan={2}>Campaña</th>
                <th className="text-left px-4 py-2" rowSpan={2}>Tipo</th>
                <th className="text-center px-4 py-2 border-l border-slate-200" colSpan={2}>Personas escritas</th>
                <th className="text-center px-4 py-2 border-l border-slate-200" colSpan={2}>Respondieron</th>
                <th className="text-center px-4 py-2 border-l border-slate-200" colSpan={2}>Costo USD</th>
              </tr>
              <tr className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
                <th className="text-right px-4 py-2 border-l border-slate-200 font-normal">Media/día</th>
                <th className="text-right px-4 py-2 font-normal">Total mes</th>
                <th className="text-right px-4 py-2 border-l border-slate-200 font-normal">Media/día</th>
                <th className="text-right px-4 py-2 font-normal">Total mes</th>
                <th className="text-right px-4 py-2 border-l border-slate-200 font-normal">Media/día</th>
                <th className="text-right px-4 py-2 font-normal">Total mes</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {campanas.map(c => {
                const pausada = c.estado === 'pausada'
                const costoMediaDia = c.stats.personasHoy * 0.0125
                const respMes = c.stats.personasHoy > 0 ? Math.round(c.stats.respondieronHoy * (c.stats.totalMes / c.stats.personasHoy)) : 0
                return (
                  <tr key={c.id} className={cn('hover:bg-slate-50', pausada && 'opacity-60')}>
                    <td className="px-4 py-3 font-medium text-navy-700">{c.nombre}</td>
                    <td className="px-4 py-3">
                      <Chip variant={c.tipo === 'mora' ? 'rose' : c.tipo === 'preventiva' ? 'blue' : 'violet'}>{c.tipo}</Chip>
                    </td>
                    <td className="px-4 py-3 text-right font-mono text-slate-700 border-l border-slate-200">
                      {pausada ? '—' : fmtNumber(c.stats.personasHoy)}
                    </td>
                    <td className="px-4 py-3 text-right font-mono text-navy-700 font-semibold">
                      {fmtNumber(c.stats.totalMes)}
                    </td>
                    <td className="px-4 py-3 text-right font-mono text-emerald-600 border-l border-slate-200">
                      {pausada ? '—' : fmtNumber(c.stats.respondieronHoy)}
                    </td>
                    <td className="px-4 py-3 text-right font-mono text-emerald-700 font-semibold">
                      {fmtNumber(respMes)}
                    </td>
                    <td className="px-4 py-3 text-right font-mono text-amber-600 border-l border-slate-200">
                      {pausada ? '—' : fmtMoney(costoMediaDia)}
                    </td>
                    <td className="px-4 py-3 text-right font-mono text-amber-700 font-semibold">
                      {fmtMoney(c.stats.costoMes)}
                    </td>
                  </tr>
                )
              })}
            </tbody>
            <tfoot>
              <tr className="bg-slate-50 border-t-2 border-slate-200 font-semibold">
                <td className="px-4 py-3 text-navy-700">Total</td>
                <td className="px-4 py-3"></td>
                <td className="px-4 py-3 text-right font-mono border-l border-slate-200 text-navy-700">
                  {fmtNumber(totalPersonasMediaDia)}
                </td>
                <td className="px-4 py-3 text-right font-mono text-navy-700">
                  {fmtNumber(mensajesMes)}
                </td>
                <td className="px-4 py-3 text-right font-mono text-emerald-700 border-l border-slate-200">
                  {fmtNumber(campanas.reduce((a, c) => a + c.stats.respondieronHoy, 0))}
                </td>
                <td className="px-4 py-3 text-right font-mono text-emerald-700">
                  {fmtNumber(totalRespMes)}
                </td>
                <td className="px-4 py-3 text-right font-mono text-amber-700 border-l border-slate-200">
                  {fmtMoney(totalCostoMedia)}
                </td>
                <td className="px-4 py-3 text-right font-mono text-amber-700">
                  {fmtMoney(totalMes)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>

      <section className="bg-white border border-slate-200 rounded-xl p-5">
        <h2 className="font-display text-lg text-navy-700 mb-3">Costos por template</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {templates.map(t => (
            <div key={t.name} className="border border-slate-200 rounded-lg p-3">
              <div className="font-mono text-sm font-semibold text-navy-700">{t.name}</div>
              <div className="flex items-baseline justify-between mt-2">
                <div className="text-xs text-slate-500">por mensaje</div>
                <div className="font-mono text-lg font-semibold text-amber-600">{fmtMoney(t.costo)}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
